( function() {
	'use strict';

	const promoBanner = document.querySelector( '.promo-banner-container[data-module="promo"]' );
	const promoCloseButtons = document.querySelectorAll( '.promo-inner span.close' );
	const stickyPromoBanners = document.querySelectorAll( '.promo-banner-sticky' );

	if ( !stickyPromoBanners.length ) {
		return;
	}

	function setTopPosition() {
		const stickyDesktopNav = document.querySelector( '.sticky-desktop-nav' );
		if ( !stickyDesktopNav ) {
			stickyPromoBanners.forEach( function( banner ) {
				banner.style.top = '0px';
			} );
		}
	}

	// This functionality was requested to be disabled as per PS-16366.
	// Original jQuery scroll/fade-in behavior intentionally left disabled.

	document.addEventListener( 'DOMContentLoaded', setTopPosition );
	window.addEventListener( 'resize', setTopPosition );

	promoCloseButtons.forEach( function( button ) {
		button.addEventListener( 'click', function() {
			if ( promoBanner instanceof HTMLElement ) {
				promoBanner.style.display = 'none';
			}
		} );
	} );
} )();
